export const FeatureToggles = {
  downloadPreviewPdf: false,
  questionsBlock: false,
  reviewsBlock: false,
  showLyrics: false,
  subscribeBlock: false,
  shareIcon: false,
};
